module.exports = __webpack_public_path__ + "img/icon-admin-lock-on.9f092430.svg";